<div class="container-input-file w-100">
    <div class="input-file-title text-center py-2">
        {{title}}
    </div>
    <div class="input-file-content d-flex flex-nowrap justify-content-between align-items-center w-100 px-2">
        <ng-container *ngIf="!isLoad; else loaded">
            <div class="w-100 d-flex justify-content-center align-items-center py-2">
                <img src="assets/images/otros/upload.svg">
                <div class="upload-text ml-2" (click)="file.click()">Cargar documento</div>
                <input hidden (change)="guardaYMuestraImagen($event)"
                accept="image/jpeg, application/pdf, image/jpg, image/png" #file type="file" id="file" [name]="typeImage" />
            </div>
        </ng-container>
        <ng-template #loaded>
            <div class="d-flex justify-content-start align-items-center py-2">
                <img src="assets/images/otros/clip.svg">
                <div class="ml-2">{{name_adjunto | truncateWord : 10 }}</div>
            </div>
            <div class="">
                <img class="pointer" (click)="eliminarImagen()" src="assets/images/otros/delete.svg">
            </div>
        </ng-template>
    </div>
</div>